import { Box, styled } from '@ltvco/refresh-lib/theme';

import { StyledAccordion } from '../../../shared';

export const TranscriptContentBox = styled(Box)(({ theme }) => ({
  maxHeight: 250,
  overflowY: 'auto',
  padding: theme.spacing(2),
  paddingRight: theme.spacing(2.5),
  backgroundColor: theme.palette.grey[50],
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1.5),
  textAlign: 'left',
  '&::-webkit-scrollbar': {
    width: '8px',
    borderRadius: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: theme.palette.grey[100],
    borderRadius: '8px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.text.secondary,
    borderRadius: '8px',
    border: `2px solid ${theme.palette.grey[100]}`,
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5),
    paddingRight: theme.spacing(2),
    maxHeight: 200,
    borderRadius: theme.spacing(1),
  },
}));

export const OralArgumentTranscriptAccordion = styled(StyledAccordion)(
  ({ theme }) => ({
    '& .MuiAccordionSummary-content': {
      color: theme.palette.common.black,
      fontWeight: 700,
    },
    '& .MuiAccordionSummary-content .MuiTypography-root': {
      color: `${theme.palette.common.black} !important`,
      fontWeight: '700 !important',
    },
    '& .MuiAccordionSummary-content p': {
      color: `${theme.palette.common.black} !important`,
      fontWeight: '700 !important',
    },
    '& .MuiAccordionSummary-content span': {
      color: `${theme.palette.common.black} !important`,
      fontWeight: '700 !important',
    },
    [theme.breakpoints.down('sm')]: {
      '& .MuiAccordionSummary-root': {
        padding: theme.spacing(1.25, 2),
      },
      '& .MuiAccordionDetails-root': {
        padding: theme.spacing(1.5),
      },
    },
  })
);
